<template>
  <section class="usuario-form-section">
    <header class="usuario-form-section__header">
      <span class="usuario-form-section__title">
        <i v-if="icon" :class="icon" aria-hidden="true" />
        {{ title }}
      </span>
      <p v-if="description" class="usuario-form-section__description">{{ description }}</p>
    </header>

    <div class="usuario-form-section__body">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'UsuarioFormSection',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.usuario-form-section {
  background: var(--lp-surface);
  border: 1px solid var(--lp-border);
  border-radius: var(--border-radius-lg);
  margin-bottom: var(--spacing-lg);
  box-shadow: var(--lp-card-shadow);
}

.usuario-form-section__header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: var(--spacing-md) var(--spacing-lg);
}

.usuario-form-section__title {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  font-size: 1rem;
  font-weight: 600;
  color: var(--lp-text-muted);
}

.usuario-form-section__title i {
  color: var(--lp-accent);
}

.usuario-form-section__description {
  margin: var(--spacing-xs) 0 0;
  font-size: 0.85rem;
  color: var(--lp-text-placeholder);
  font-style: italic;
}

.usuario-form-section__body {
  padding: 0 var(--spacing-lg) var(--spacing-lg);
}
</style>
